import Color from '../Color.mjs'
import superMeta from '../_COMPONENT/metaComponentNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.CYAN,
    codeProp: 'ieUserCode',
    name: '指标实体',
    ownerIdProp: 'aoId',
    ownerTextProp: 'aoName',
    ownerType: 'AO',
    textProp: 'ieTitle',
    type: 'IE',
}
